import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { CasePreview } from '../';
import Info from '../Icons/Info';
const FromCase = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const fromCase = useSelector((s) => singleCase &&
        singleCase.fromCaseId &&
        selectCaseById(s, singleCase.fromCaseId));
    useEffect(() => {
        if (singleCase && singleCase.fromCaseId && !fromCase) {
            c.cases.getById(singleCase.fromCaseId);
        }
    }, [singleCase]);
    if (!singleCase || !singleCase.fromCaseId || !fromCase) {
        return null;
    }
    return (React.createElement("p", null,
        React.createElement("div", { className: "case-info-title", "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.cases.sourceClient, style: { display: 'inline-block' } },
            lang.cases.source,
            " ",
            React.createElement(Info, null),
            ' '),
        React.createElement("div", null,
            React.createElement(CasePreview, { caseId: fromCase.id }))));
};
export default FromCase;
//# sourceMappingURL=FromCase.js.map